<template>
  <c-row>
    <c-col col="12">
      <c-card>
        <c-card-header>
          <c-card-title>
            <strong>Informasi Transaksi Penjualan</strong>
            <div class="card-header-actions">
              <date-range @select="changeDate" />
            </div>
          </c-card-title>
        </c-card-header>
        <c-card-body>
          <div style="overflow: auto">
            <table class="table table-bordered">
              <thead>
                <tr>
                  <th>No</th>
                  <th>Tanggal</th>
                  <th>Faktur</th>
                  <th>Customer</th>
                  <th>Petugas</th>
                  <th>Kode Item & Garansi</th>
                  <th>Nama</th>
                  <th>Qty</th>
                  <th>HPP</th>
                  <th>Jual</th>
                  <th>Laba</th>
                  <th>Total</th>
                </tr>
              </thead>
              <tbody v-if="report.data && report.data.length <= 0">
                <tr>
                  <td colspan="12" class="center">
                    Data tidak ditemukan untuk range tanggal
                    <strong>{{ this.dateRange.startDate.format("DD-MMM-YYYY") }} sd.
                      {{ this.dateRange.endDate.format("DD-MMM-YYYY") }}</strong>
                  </td>
                </tr>
              </tbody>
              <tbody v-else v-for="(v, k) in report.data" :key="k">
                <tr>
                  <td :rowspan="v.details.length + 1">
                    <table-number :index="k" :paginate="report.paginate" />
                  </td>
                  <td style="width: 100px" :rowspan="v.details.length + 1">
                    {{ v.created_at | dateTimeFormat }}
                  </td>
                  <td style="width: 120px" :rowspan="v.details.length + 1">
                    {{ v.faktur }}
                  </td>
                  <td style="width: 220px" :rowspan="v.details.length + 1">
                    {{ v.customer_name }}
                  </td>
                  <td style="width: 70px" :rowspan="v.details.length + 1">
                    {{ v.user_name }}
                  </td>
                </tr>
  
                <tr v-for="(d, ky) in v.details" :key="ky">
                  <td style="width: 165px" class="center">
                    {{ d.warranty_code }}
                  </td>
                  <td>{{ d.item_name }}</td>
                  <td class="right" style="width: 41px; border-right: none">
                    {{ d.qty }}
                  </td>
                  <td class="right" style="width: 90px; border-right: none">
                    {{ d.hpp | thousandSeparator }}
                  </td>
                  <td class="right" style="width: 90px; border-right: none">
                    {{ d.price | thousandSeparator }}
                  </td>
                  <td class="right" style="width: 80px; border-right: none">
                    {{ d.laba | thousandSeparator }}
                  </td>
                  <td class="right" style="width: 90px; border-right: none">
                    {{ d.sub_total | thousandSeparator }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-card-body>
        <c-card-footer>
          <button class="btn btn-primary" @click="doPrint">
            <i class="cil-print"></i> Print</button>&nbsp;
          <button class="btn btn-success" @click="exportExcel">
            <i class="cil-cloud-download"></i> Excel
          </button>
          <Paginator :paginator="report.paginate" @change="changePage" />
        </c-card-footer>
      </c-card>
    </c-col>
  </c-row>
</template>
<script>
import { HTTPAUTH, HTTPExport } from "../../lib/httplib";
import TableNumber from "../../components/TableNumber2";
import DateRange from "../../components/DateRange";
import Paginator from '../../components/Paginator.vue';

export default {
  data () {
    return {
      report: {},
      currentPage: 1,
      total: 0,
      perPage: 10,
      startMonth: moment(moment().format("YYYY-MM-") + "01"),
      dateRange: {},
    };
  },
  components: {
    TableNumber,
    DateRange,
    Paginator,
  },
  created () {
    this.dateRange = {
      startDate: this.startMonth,
      endDate: moment(),
    };
    this.getList(1, "");
    // this.$store.state.sidebarMinimize = true;
  },
  methods: {
    getList (page, q) {
      var dateRange = "";
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
        dateRange = `&start_date=${startDate}&end_date=${endDate}`;
      }
      HTTPAUTH.get(
        `/api/v1/report-transaction/sale?page=${page}&size=${this.perPage}&q=${q}${dateRange}`
      ).then((res) => {
        this.report = res.data;
        this.currentPage = page;
        this.total = this.report.paginate.total;
        this.$router.push({
          query: { q: q, page: page, start: startDate, end: endDate },
        });
      });
    },
    changeDate (v) {
      this.dateRange = {
        startDate: moment(v.startDate),
        endDate: moment(v.endDate),
      };
      this.getList(1, "");
    },
    doPrint () {
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
      }
      const routeData = this.$router.resolve({ path: `/print/journal/income-statement/sales`, query: { start_date: startDate, end_date: endDate } })
      window.open(routeData.href, '_blank')
    },
    exportExcel () {
      var startDate = "";
      var endDate = "";
      if (this.dateRange) {
        startDate = this.dateRange.startDate.format("YYYY-MM-DD");
        endDate = this.dateRange.endDate.format("YYYY-MM-DD");
      }
      HTTPExport.get(`/api/v1/exports/journal/income-statement-sales?start_date=${startDate}&end_date=${endDate}`).then(res => {
        const data = res.data.data;
        window.open(data, '_blank');
      })
    },
    changePage (page) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(page, q);
    }
  },
  watch: {
    currentPage (pageNext) {
      const query = this.$route.query;
      var q = "";
      if (query.q) {
        q = query.q;
      }
      this.getList(pageNext, q);
    },
  },
};
</script>